import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ria-client/tw-shadcn/components/tabs';
import type { DriverMappingConfig } from '../lib/financial-advisors/types';
import { CardDetails } from './card-details';
import { CardDrivers } from './card-drivers';

export interface CardTabsProps {
  marketplaceEntity: Record<string, unknown> & {
    prosBullets?: string[];
    consBullets?: string[];
    tagline?: string;
  };
  drivers: DriverMappingConfig[];
  showMoreDetails: boolean;
}

export function CardTabs({ marketplaceEntity, drivers, showMoreDetails }: CardTabsProps) {
  return (
    <Tabs defaultValue="overview">
      <TabsList>
        <TabsTrigger value="overview">OVERVIEW</TabsTrigger>
        {showMoreDetails ? <TabsTrigger value="more-details">MORE DETAILS</TabsTrigger> : null}
      </TabsList>
      <TabsContent className="pt-3" value="overview">
        <CardDrivers drivers={drivers} marketplaceEntity={marketplaceEntity} />
      </TabsContent>
      {showMoreDetails ? (
        <TabsContent className="pt-3" value="more-details">
          <CardDetails
            consBullets={marketplaceEntity.consBullets}
            prosBullets={marketplaceEntity.prosBullets}
            tagline={marketplaceEntity.tagline}
          />
        </TabsContent>
      ) : null}
    </Tabs>
  );
}
